import { normalizeTimeHms } from './calendarEvents';

function slotIsAvailable(slot) {
  const v = slot?.is_available;
  if (v === false || v === 0 || v === '0' || v === 'f' || v === 'false') return false;
  return true;
}

/**
 * Map teacher_availability rows to FullCalendar businessHours.
 * Recurring weekdays only — same contract as classes (naive wall-clock).
 * Empty array means "do not set businessHours" so the grid stays unchanged.
 */
export function availabilityToBusinessHours(slots) {
  const ranges = [];
  for (const slot of slots || []) {
    if (!slotIsAvailable(slot)) continue;
    const start = normalizeTimeHms(slot.start_time);
    const end = normalizeTimeHms(slot.end_time);
    if (!start || !end || start >= end) continue;
    const day = Number(slot.day_of_week);
    if (!Number.isInteger(day) || day < 0 || day > 6) continue;
    ranges.push({
      daysOfWeek: [day],
      startTime: start,
      endTime: end,
    });
  }
  return ranges;
}

/** Earliest working-hour start as HH:mm:ss, or null when hours are not set. */
export function earliestAvailabilityScrollTime(slots) {
  const ranges = availabilityToBusinessHours(slots);
  if (!ranges.length) return null;
  let min = ranges[0].startTime;
  for (const range of ranges) {
    if (range.startTime < min) min = range.startTime;
  }
  return min;
}
